module.exports = __webpack_public_path__ + "static/img/assistant02a.0315f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/assistant02a.png
// module id = EMMv
// module chunks = 1